// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import type { PostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationResult } from "./types";

export const isPostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationResult =
  objectOf<PostwsGenerativeAiAppGroupIdBrandGuidelinesEvaluationResult>({
    status: number,
    valid: maybe(boolean, true),
    assessment: maybe(string, true),
    suggestion: maybe(string, true),
    error_code: maybe(string, true),
  });
